import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./export.module.scss";
import i18next from "i18next";
import PageTitle from "../../components/pageTitle/PageTitle";
import SubTable from "../../components/subTable/SubTable";
import DealerExportForm from "./components/DealerExportForm";
import TextBoxCompOne from "../../components/textBoxCompOne/TextBoxCompOne";
import StatusText from "../../components/statusText/StatusText";
import { getStatusClassName } from "../../utils/commonFuntion";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useApiErrorModalContext } from "../../errorHandling/ApiErrorModalContext";
import { getDealerList } from "../../services/APIService";
import _ from "lodash";
export function TooltipWrapper(valType, val, styleval) {
  if (valType === "header") {
    if (val?.length <= 20) return val;
    else
      return (
        <Tooltip
          disableInteractive
          title={val}
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltip": {
                width: "180px",
                padding: "2px 0px",
                textAlign: "center",
                fontSize: "12px",
                color: "common.white",
                backgroundColor: "#808080",
                borderRadius: "5px",
              },
            },
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -5],
                },
              },
            ],
          }}
        >
          <Box className={styleval}>{`${String(val).slice(0, 20)}.....`}</Box>
        </Tooltip>
      );
  } else if(valType === "subText") {
    if (val?.length <= 30) return val;
    else
      return (
        <Tooltip
          disableInteractive
          title={val}
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltip": {
                width: "180px",
                padding: "3px 3px",
                fontSize: "12px",
                color: "common.white",
                backgroundColor: "#808080",
                borderRadius: "5px",
                whiteSpace: "break-spaces",
              },
            },
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -5],
                },
              },
            ],
          }}
        >
          <Box className={styleval}>{`${String(val).slice(0, 30)}.....`}</Box>
        </Tooltip>
      );
  }
}

const DealerExport = () => {
  const [tableColumnData, setTableColumnData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const history = useNavigate();
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [dealersList, setDealersList] = useState([]);
  const defaultDealerApiParam = {
    IsDesc: false,

    PageNumber: 1,
    PageSize: 5,
    Status: 3,
  };

  useEffect(() => {
    getDealerList(defaultDealerApiParam)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDealersList(_.get(response, "dealerDtoList", []));
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const tableHeaderColumns = [
      {
        field: "dealerName",
        headerName: i18next.t("Dealer"),
        flex: 2,
        sortable: false,
        renderCell: (params) => (
          <TextBoxCompOne
            headerText={TooltipWrapper(
              "header",
              params.row?.dealerName,
              styles.headerText
            )}
            subText={TooltipWrapper(
              "subText",
              "Langschoten 58, 7371 EP Loenen",
              styles.delearSubText
            )}
            // ${params.row.street} - use later
            headerTextStyle={styles.headerText}
            subTextStyle={styles.delearSubText}
            onheaderClick={() => {}}
          />
        ),
      },
      {
        field: "status",
        headerName: i18next.t("Status"),
        flex: 1.6,
        sortable: false,
        renderCell: (params) => (
          <StatusText
            title={params.row?.status}
            customClass={getStatusClassName(params.row?.status)}
            hasIcon={false}
            data-testid="status"
            showPopover={false}
            defaultId={params.row?.dealer_Id} // should add field along with id
            defaultStatus={params.row?.status} // pass field name also while api integration
          />
        ),
      },

      {
        field: "noofvehicles",
        sortable: false,

        headerName: (
          <Box className={styles.twoLineColumn}>
            {i18next.t("Active vehicles")}
          </Box>
        ),
        flex: 1.0,
        renderCell: (params) => (
          <Box
            className={styles.vehicleNbrText}
            onClick={() => {}}
            onKeyDown={() => {}}
          >
            {params.row?.noofvehicles}
          </Box>
        ),
      },
    ];
    setTableHeader(tableHeaderColumns);

    setTableColumnData(dealersList);
  }, [dealersList]);

  return (
    <Box className={`${styles.dealerExportWrapper}`} data-testid="DealerExport">
      <PageTitle
        title={`${i18next.t("Selecteer gegevens exportbestand Bedrijven")}`}
        data-testid="pagetitle"
      />
      <Box className={`twoSectionPageWrapper`}>
        <Box className={`${styles.leftContentWrapper} leftSideWrapper`}>
          <DealerExportForm />
        </Box>
        <Box className={`${styles.rightContentWrapper} rightSideWrapper`}>
          <Box className={styles.dealerSubTable}>
            <SubTable
              tableHeader={tableHeader}
              tableColumnData={tableColumnData}
              title={i18next.t("Recent dealers")}
              handleBtnAction={() =>
                history("/dealers", { state: { currentTab: 1 } })
              }
            />

            <Box className={styles.tableAction}></Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default DealerExport;
